import { INITIALIZING_AUTH, SIGNIN, SIGNIN_FAILED, SIGNOUT } from "./authTypes";
import db, { firebase } from "../../firebaseConfig";
import {ADMINS_COLLECTION} from "../../constants";

export const signin = user => {
    return {
        type: SIGNIN,
        payload: user
    }
}

export const signout = () => {
    return {
        type: SIGNOUT,
    }
}

export const signInFailed = error => {
    return {
        type: SIGNIN_FAILED,
        payload: error
    }
}

export const initializing = () => {
    return {
        type: INITIALIZING_AUTH
    }
}

export const signInWithProvider = provider => {
    return async (dispatch) => {
        
        await firebase.auth().signInWithPopup(provider).then(response => {
            const newUser = {
                uid: response.user?.uid,
                type: null,
                email: response.user?.email,
                displayName: response.user?.displayName,
                phoneNumber: response.user?.phoneNumber,
                photoURL: response.user?.photoURL,
                isAnonymous: response.user?.isAnonymous,
                createdAt: new Date(),
                updatedAt: new Date()
            }
            if (response === null) {
                dispatch(signInFailed('SignIn Failed!'));
                // authDispatch({type:'UPDATE', payload: null});
            } else {
                db.collection(ADMINS_COLLECTION).doc(response.user?.uid).get().then((doc) => {
                    // console.log(doc.exists)
                    if (doc.exists === false) {
                        db
                        .collection(ADMINS_COLLECTION)
                        .doc(response.user?.uid)
                        .set(newUser);

                        dispatch(signin(newUser));
                    } else {
                        dispatch(signin({
                            uid: doc.data()?.uid,
                            type: doc.data()?.type,
                            email: doc.data()?.email,
                            displayName: doc.data()?.displayName,
                            phoneNumber: doc.data()?.phoneNumber,
                            photoURL: doc.data()?.photoURL,
                            isAnonymous: doc.data()?.isAnonymous,
                            createdAt: doc.data()?.createdAt,
                            updatedAt: doc.data()?.updatedAt
                        }));
                    }
                }).catch((error) => {
                    dispatch(signInFailed(error.message));
                });
            }
        }).catch(error => {
            dispatch(signInFailed(error.message));
        });
    }
}

export const checkAuthentication = () => {
    // console.log('initializing');
    return async (dispatch) => {
        dispatch(initializing());
        await firebase.auth().onAuthStateChanged(async user => {
            if(user) {
                await db.collection(ADMINS_COLLECTION).doc(user?.uid).get().then((doc) => {
                    if (doc.exists === true) {
                        dispatch(signin({
                            uid: doc.data()?.uid,
                            type: doc.data()?.type,
                            email: doc.data()?.email,
                            displayName: doc.data()?.displayName,
                            phoneNumber: doc.data()?.phoneNumber,
                            photoURL: doc.data()?.photoURL,
                            isAnonymous: doc.data()?.isAnonymous,
                            createdAt: doc.data()?.createdAt,
                            updatedAt: doc.data()?.updatedAt
                        }));
                    } else {
                        dispatch(signInFailed(''));
                    }
                }).catch((error) => {
                    dispatch(signInFailed(error.message));
                });
            } else {
                dispatch(signInFailed(''));
            }
        });
    }
}

export const authSignOut = () => {
    return async (dispatch) => {
        dispatch(initializing());
        await firebase.auth().signOut();
        dispatch(signout());
    }
}